import { fetchRooms } from "../services";
import * as chatSlice from "./ChatSlice.v2";

type ChatType = "allChat" | "myChat";

export const loadRoomsForCollaboration =
  ({
    chatType,
    collaborationId,
    preferredRoomId,
    source = "selected_collaboration",
  }: {
    chatType: ChatType;
    collaborationId: string;
    preferredRoomId?: string | null;
    source?: string;
  }) =>
  async (dispatch: any, getState: any) => {
    if (!collaborationId) return;

    const currentCollaboration =
      getState()?.ChatV2?.[chatType]?.collaborationsById?.[collaborationId];
    const currentRooms = currentCollaboration?.roomsModel ?? [];

    if (currentRooms.length) {
      const roomId =
        preferredRoomId && currentRooms.some((room: any) => room.id === preferredRoomId)
          ? preferredRoomId
          : currentRooms[0]?.id;

      if (roomId) {
        dispatch(chatSlice.setSelectedRoom({ chatType, id: roomId }));
      }
      return;
    }

    const rooms = await fetchRooms(collaborationId, source);
    dispatch(chatSlice.setCollaborationRooms({ chatType, collaborationId, rooms }));

    const roomId =
      preferredRoomId && rooms.some((room) => room.id === preferredRoomId)
        ? preferredRoomId
        : rooms[0]?.id;

    if (roomId) {
      dispatch(chatSlice.setSelectedRoom({ chatType, id: roomId }));
    }
  };
